import { calculateMemory } from '@/utils/calc-tools';

/** 将 K8s storage 字符串或数字解析为 Gi 数值（storage / image-vm 共用） */
export function parseGiSize(raw: unknown): number {
  const formatted = calculateMemory([raw as string | number | undefined], { forceUnit: 'Gi' });
  const size = parseFloat(formatted);
  return Number.isNaN(size) ? 1 : size;
}
